<template>
  <el-card class="box data">
    <el-tabs type="border-card" style="height: 100%">
      <el-tab-pane label="分词测试">
        <el-form :inline="true">
          <el-form-item label="">
            <el-input
              v-model="q"
              placeholder="请输入楼盘名称"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="search" @click="onAnalyze"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <el-table :data="tokens" border>
            <el-table-column label="分词" prop="token"></el-table-column>
            <el-table-column label="type" prop="type"></el-table-column>
            <el-table-column label="position" prop="position"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="关键字检索">
        <el-form :inline="true">
          <el-form-item label="">
            <el-input
              v-model="keywords"
              placeholder="请输入楼盘名称"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="search" @click="onKeywordSearch"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <el-table :data="keySearchDocList" border>
            <el-table-column label="id" prop="id"></el-table-column>
            <el-table-column label="楼盘名称" prop="name"></el-table-column>
            <el-table-column label="AreaId" prop="areaId"></el-table-column>
            <el-table-column label="序号" prop="orderNum"></el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- <el-tab-pane label="报备时检索"> </el-tab-pane> -->
    </el-tabs>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      q: "",
      keywords:'',
      tokens: [],
      keySearchDocList:[],
    };
  },
  methods: {
    onAnalyze () {
      this.$http.get("v1/common/es/analyze?q=" + this.q).then((res) => {
        if (res.code === 0) {
          this.tokens = res.data;
        }
      });
    },

    /**
     * 
     */
    onKeywordSearch(){
        this.$http.get("v1/common/es/search?q=" + this.keywords).then((res) => {
        if (res.code === 0) {
          this.keySearchDocList = res.data;
        }
      });
    }
  },


};
</script>

<style lang="scss" scoped></style>
